import React from "react";
import AuthenticatedMedia from "../AuthenticatedMedia";
import { sanitizeEditorHtml } from "../CompactPostEditor";
import { captionLimits, formatPostDate, hashtagsToText, platformIcon, platformName, plainCaption } from "./postStudioUtils";

const previewMedia = (post) => {
  if (post.media?.length) return post.media;
  return [post.imageUrl && { id: "image", url: post.imageUrl, mimeType: "image/*" }, post.videoUrl && { id: "video", url: post.videoUrl, mimeType: "video/*" }].filter(Boolean);
};

// A platform-style rendering of a post. richText renders the sanitized manual-editor HTML.
const PostPreview = ({ post, accountName, richText = false, compact = false }) => {
  const media = previewMedia(post);
  const [primary, ...more] = media;
  const caption = plainCaption(post);
  const limit = captionLimits[post.platform];
  const hashtags = hashtagsToText(post.hashtags);

  return <article className={`studio-preview platform-${post.platform || "none"}${compact ? " is-compact" : ""}`} aria-label="Post preview">
    <header className="studio-preview-head">
      <span className="studio-preview-avatar" aria-hidden="true"><i className={`ti ${platformIcon(post.platform)}`} /></span>
      <span className="studio-preview-account"><strong>{accountName || platformName(post.platform)}</strong><small>{formatPostDate(post.scheduledAt)}</small></span>
    </header>
    {post.title && <h3 className="studio-preview-title">{post.title}</h3>}
    {richText && post.description
      ? <div className="studio-preview-copy is-rich" dangerouslySetInnerHTML={{ __html: sanitizeEditorHtml(post.description) }} />
      : <p className="studio-preview-copy">{caption || <span className="studio-muted">Your caption will appear here.</span>}</p>}
    {!richText && post.description && post.description !== caption && <p className="studio-preview-description">{post.description}</p>}
    {post.emojis && !caption.includes(post.emojis) && <p className="studio-preview-emojis">{post.emojis}</p>}
    {hashtags && <p className="studio-preview-hashtags">{hashtags}</p>}
    {post.cta && <p className="studio-preview-cta"><i className="ti ti-arrow-right" aria-hidden="true" /> {post.cta}</p>}
    {primary && <div className="studio-preview-media">
      {primary.mimeType?.startsWith("video/") ? <AuthenticatedMedia src={primary.url} video controls={!compact} muted /> : <AuthenticatedMedia src={primary.url} alt="Post media" />}
      {more.length > 0 && <span className="studio-preview-more">+{more.length}</span>}
    </div>}
    {limit && caption.length > limit && <p className="studio-preview-warning" role="status"><i className="ti ti-alert-triangle" aria-hidden="true" /> {caption.length}/{limit} characters — {platformName(post.platform)} may truncate or reject this caption.</p>}
  </article>;
};

export default PostPreview;
